import React from "react";
import PDFIcon from "../../assets/images/icons/pdf-icon.svg";
import Download from "../../assets/images/icons/download-icon.svg";
import UploadIcon from "../../assets/images/icons/upload.svg";

export const resolveDocumentUrl = (value) => {
  if (!value || typeof value !== "string") return null;
  if (value.startsWith("http") || value.startsWith("blob:") || value.startsWith("data:")) {
    return value;
  }
  const base = process.env.REACT_APP_IMAGE_URL || "";
  if (!base) return value;
  return `${base.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
};

export const DocumentViewCard = ({ title, documentLabel, url }) => {
  const resolvedUrl = resolveDocumentUrl(url);

  return (
    <div className="col-md-4 p-2">
      <div className="rounded-14 border d-flex align-items-center p-3 document-view-card">
        <div className="flex-fill">
          <strong>{title}</strong>
          <div className="small d-flex align-items-center mt-2">
            <img src={PDFIcon} alt="pdf" className="mr-2 document-view-card__pdf-icon" />
            {resolvedUrl ? (
              <a
                href={resolvedUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-primary"
              >
                {documentLabel}
              </a>
            ) : (
              <span>No document available</span>
            )}
          </div>
        </div>
        {resolvedUrl ? (
          <a href={resolvedUrl} target="_blank" rel="noopener noreferrer" aria-label={`Download ${title}`}>
            <img src={Download} alt="download" className="document-view-card__download-icon" />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export const DocumentUploadCard = ({ title, documentLabel, previewUrl, hasFile, onFileChange, name, accept = "image/*,application/pdf,.pdf" }) => {
  const openUrl = previewUrl ? resolveDocumentUrl(previewUrl) : null;
  const inputId = `document-upload-${name}`;

  const handleOpenPreview = (e) => {
    e.preventDefault();
    if (!openUrl) return;
    window.open(openUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="col-md-4 p-2">
      <div className="rounded-14 border d-flex align-items-center p-3 document-view-card">
        <div className="flex-fill">
          <strong>{title}</strong>
          <div className="small d-flex align-items-center mt-2">
            <img src={PDFIcon} alt="pdf" className="mr-2 document-view-card__pdf-icon" />
            {openUrl ? (
              <a
                href={openUrl}
                onClick={handleOpenPreview}
                className="text-decoration-none text-primary"
                role="button"
              >
                {documentLabel}
              </a>
            ) : hasFile ? (
              <span className="text-primary">Preparing preview…</span>
            ) : (
              <label htmlFor={inputId} className="mb-0 text-primary document-view-card__upload-label">
                Click to upload document
              </label>
            )}
          </div>
          {!hasFile && <span className="small d-block mt-1 text-muted">No document uploaded</span>}
          <input id={inputId} type="file" className="d-none" name={name} accept={accept} onChange={onFileChange} />
        </div>
        <label htmlFor={inputId} className="mb-0 document-view-card__upload-label" aria-label={`Upload ${title}`}>
          <span className="document-view-card__upload-action">
            <img src={UploadIcon} alt="upload" className="document-view-card__upload-action-icon" />
          </span>
        </label>
      </div>
    </div>
  );
};
